import { render } from "./instructor-wishlist.vue?vue&type=template&id=2a3446e0"
import script from "./instructor-wishlist.vue?vue&type=script&lang=js"
export * from "./instructor-wishlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__